import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { callApi, getInlineLoader } from "../Helpers"
import CategoryHero from "../ones/CategoryHero"
import Footer from "../ones/Footer"
import LibraryItemCard from "../ones/LibraryItemCard"


export default function PurchasedAccess() {

  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const [purchasedItems, setPurchasedItems] = useState([]);

  async function init() {
    setReady(false);
    await callApi('get-my-library', {}).then((response) => {
      if (response.status === 1) {
        setPurchasedItems(response.data.purchasedItems || []);
      } else {
        setPurchasedItems([]);
        appContext.tellError(response.msg || 'Could not load purchased access');
      }
    })
    setReady(true);
  }

  useEffect(() => {
    init();
  }, [])

  return (
    <>
      <CategoryHero
        eyebrow="PURCHASED ACCESS"
        title="Content available in your library."
        description="Open books, videos, journals and stories that you have successfully purchased."
      />

      <div className="container marketplace-page-container">
        <h6 className="main-section-title">Purchased Access</h6>
        {
          ready ?
            purchasedItems.length > 0 ?
              <div className="row g-4">
                {
                  purchasedItems.map((item) => {
                    return (
                      <div className="col-12 col-sm-6 col-lg-4" key={item.uuid}>
                        <LibraryItemCard data={item} />
                      </div>
                    )
                  })
                }
              </div>
              :
              <div className="marketplace-empty-state">You have not purchased any content yet.</div>
            :
            <div className="mSupportLoading">{getInlineLoader()}</div>
        }
      </div>

      <Footer />
    </>
  )
}
